/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareExistingPatient } from './MatrixCareExistingPatient';
import {
    MatrixCareExistingPatientFromJSON,
    MatrixCareExistingPatientFromJSONTyped,
    MatrixCareExistingPatientToJSON,
    MatrixCareExistingPatientToJSONTyped,
} from './MatrixCareExistingPatient';

/**
 * 
 * @export
 * @interface SearchMatrixCareHomeHealthPatientsResponse
 */
export interface SearchMatrixCareHomeHealthPatientsResponse {
    /**
     * 
     * @type {Array<MatrixCareExistingPatient>}
     * @memberof SearchMatrixCareHomeHealthPatientsResponse
     */
    matches: Array<MatrixCareExistingPatient>;
    /**
     * Total matches reported by MatrixCare. May exceed `matches.length` when the vendor result set exceeds our fixed cap.
     * @type {number}
     * @memberof SearchMatrixCareHomeHealthPatientsResponse
     */
    total: number;
    /**
     * True when `total > matches.length`. Signal to the UI to show an "and N more" message.
     * @type {boolean}
     * @memberof SearchMatrixCareHomeHealthPatientsResponse
     */
    truncated: boolean;
}

/**
 * Check if a given object implements the SearchMatrixCareHomeHealthPatientsResponse interface.
 */
export function instanceOfSearchMatrixCareHomeHealthPatientsResponse(value: object): value is SearchMatrixCareHomeHealthPatientsResponse {
    if (!('matches' in value) || value['matches'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('truncated' in value) || value['truncated'] === undefined) return false;
    return true;
}

export function SearchMatrixCareHomeHealthPatientsResponseFromJSON(json: any): SearchMatrixCareHomeHealthPatientsResponse {
    return SearchMatrixCareHomeHealthPatientsResponseFromJSONTyped(json, false);
}

export function SearchMatrixCareHomeHealthPatientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchMatrixCareHomeHealthPatientsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matches': ((json['matches'] as Array<any>).map(MatrixCareExistingPatientFromJSON)),
        'total': json['total'],
        'truncated': json['truncated'],
    };
}

export function SearchMatrixCareHomeHealthPatientsResponseToJSON(json: any): SearchMatrixCareHomeHealthPatientsResponse {
    return SearchMatrixCareHomeHealthPatientsResponseToJSONTyped(json, false);
}

export function SearchMatrixCareHomeHealthPatientsResponseToJSONTyped(value?: SearchMatrixCareHomeHealthPatientsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matches': ((value['matches'] as Array<any>).map(MatrixCareExistingPatientToJSON)),
        'total': value['total'],
        'truncated': value['truncated'],
    };
}

